import { useAuth } from '../auth/AuthContext.js';
import { LogoMark } from '../components/Logo.js';

export function PendingApproval() {
  const { me, logout } = useAuth();
  return (
    <div className="signin">
      <div className="modal pending-card" style={{ textAlign: 'center' }}>
        <div className="modal-bd" style={{ padding: 28 }}>
          <div style={{ display: 'grid', placeItems: 'center', marginBottom: 14 }}>
            <LogoMark size={54} glow />
          </div>
          <h3 style={{ margin: '0 0 6px', fontFamily: 'var(--font-disp)', letterSpacing: '0.06em' }}>
            Request sent to administrators
          </h3>
          <p className="muted" style={{ margin: '0 0 6px' }}>
            Your account <strong>{me?.user.email}</strong> has been created and is awaiting approval.
          </p>
          <p className="muted" style={{ margin: '0 0 18px' }}>
            An administrator has been notified to assign your role and department. You'll have access
            as soon as they do - check back shortly.
          </p>
          <button className="btn btn-primary pending-logout" style={{ justifyContent: 'center', minWidth: 120 }} onClick={() => void logout()}>
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}
